import React from "react";
import cs from "classnames";


export type ButtonProps = {
    title: string;
    className?: string;
    onClick: () => void
}

const Button: React.FC<ButtonProps> = ({title, className, onClick}) => {
    return <button
        type="button"
        onClick={() => {
            if (onClick) {
                onClick()
            }
        }}
        className={
            cs("inline-flex items-center px-3 py-1.5",
                "border ",
                "text-xs font-medium rounded",
                "shadow-sm text-black",
                "hover:bg-gray-100",
                "active:bg-gray-200",
                className)}
    >
        {title}
    </button>
}
export default Button;
